import React, { FC, memo } from 'react';
import styled, { css } from 'styled-components';
import { CoreTheme as theme } from '@minecraft.themes';
import { DropdownWithChildrenProps, DropdownWithChildrenContextType, SelectionsResultTypeEnum } from '../shared/types';
import { StyledClearButton, StyledClearIcon } from '../shared/styles';

const alignResult = css<{ $isPositionAbsolute: boolean }>`
  ${(props) =>
    props.$isPositionAbsolute &&
    `
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    max-width: calc(100% - 3.25rem);
`}
`;

const truncateTextWithEllipsis = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const StyledDropdownWithChildrenTextContainer = styled.div<{ $isPositionAbsolute: boolean }>`
  ${truncateTextWithEllipsis}
  ${alignResult}
`;

const StyledDropdownWithChildrenPillContainer = styled.div<{ $isPositionAbsolute: boolean }>`
  align-items: center;
  border-radius: 1.5625rem;
  background-color: ${(props): string => props.theme.colors.primary.grey1};
  display: flex;
  height: 1.5rem;
  padding-left: 0.75rem;

  ${alignResult}
`;

const StyledPillText = styled.span`
  color: ${(props): string => props.theme.colors.primary.white};
  font-size: 0.75rem;
  font-weight: 600;

  ${truncateTextWithEllipsis}
`;

interface Props {
  isPositionAbsolute: boolean;
  selectionsResult: DropdownWithChildrenContextType['selectionsResult'];
  selectionsResultType: DropdownWithChildrenProps['selectionsResultType'];
  handleSelectedOptionsClear?: DropdownWithChildrenContextType['handleSelectedOptionsClear'];
}

const DropdownWithChildrenSelectionsResult: FC<Props> = ({
  isPositionAbsolute,
  selectionsResult,
  selectionsResultType,
  handleSelectedOptionsClear,
}) => {
  if (selectionsResultType === SelectionsResultTypeEnum.jsxElement) {
    return (
      <StyledDropdownWithChildrenTextContainer $isPositionAbsolute={isPositionAbsolute} data-testid="dd-selection">
        {selectionsResult}
      </StyledDropdownWithChildrenTextContainer>
    );
  }

  return (
    <StyledDropdownWithChildrenPillContainer $isPositionAbsolute={isPositionAbsolute}>
      <StyledPillText data-testid="dd-selection" aria-label={selectionsResult}>
        {selectionsResult}
      </StyledPillText>
      <StyledClearButton onClick={handleSelectedOptionsClear}>
        <StyledClearIcon name="close" color={theme.colors.primary.white} />
      </StyledClearButton>
    </StyledDropdownWithChildrenPillContainer>
  );
};

export default memo(DropdownWithChildrenSelectionsResult);
